import { useState, useEffect } from "react";
import { Box, Card, CardActions, CardContent, Grid, TextField } from "@mui/material";
import { useData } from "../../../context/DataContext";
import { createTrainingSession } from '../../../context/createAPI';
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import SingleSelect from "../../../components/Selections/singleSelect";
import CustomButton from "../../../components/buttons/customButton";
import SnackbarMessage from "../../../components/snackBar/snackBar";

function TrainingSessionCreation() {

    const { trainingPlans = [], user = [], handleTrainingSessions, villageGroups = [], trainingSessions = [], years = [], trainingTypes = [], } = useData();

    const navigate = useNavigate();


    const [state, setState] = useState({
        training_name: "",
        training_name_error: "",
        selectedGroupIds: "",
        selectedVillageIds: "",
        selected_village_ids_error: "",
        selected_group_ids_error: "",
        schedule_date: "",
        schedule_date_error: "",
        loading: false,
        responseMessage: "",
        villageDetails: [],
        groupDetails: [],
        trainingTypeId: "",
        trainingTypeIdError: "",
    });

    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const trainingPlansInLeatestYear = trainingPlans.filter((item) => +item.year === years[0].value);
    const trainingPlanTypes = state.trainingTypeId === "" ? [] : trainingPlansInLeatestYear.filter((item) => +item.training_type_id === +state.trainingTypeId);
    const training_Plans = trainingPlanTypes.map((item) => ({ value: item.id, label: `${item.training_content}  (${moment.unix(item.month_of_training).format('MMMM-YYYY')})` }));

    const handleCheduleCreationSubmit = async (e) => {

        e.preventDefault();
        const { training_name, schedule_date, selectedVillageIds, selectedGroupIds, trainingTypeId } = state;

        if (trainingTypeId === "") {
            setState(prevState => ({ ...prevState, trainingTypeIdError: "Please Select Training Type" }));
            return;
        }

        if (training_name === "") {
            setState(prevState => ({ ...prevState, training_name_error: "Please Select Training" }));
            return;
        }

        if (!selectedVillageIds && !selectedGroupIds) {
            if (user?.level_id === 1) {
                setState(prevState => ({ ...prevState, selected_village_ids_error: "Please Select Villages" }));
            } else {
                setState(prevState => ({ ...prevState, selected_group_ids_error: "Please Select Groups" }));
            }
            return;
        }

        if (!schedule_date) {
            setState(prevState => ({ ...prevState, schedule_date_error: "Please Select Schedule Date" }));
            return;
        }
        setState((prevState) => ({ ...prevState, loading: true }));
        try {
            const params = {
                training_plan_id: state.training_name ? state.training_name : null,
                level_id: user?.level_id ? user?.level_id : null,
                session_date: Math.floor(new Date(schedule_date).getTime() / 1000),
                ff_group_id: selectedGroupIds ? selectedGroupIds : null,
                village_id: selectedVillageIds ? selectedVillageIds : null,
                training_status_id: 1,
                client_id: parseInt(localStorage.getItem("user_client_id")),
                inserted_by: user?.user_id ? user?.user_id : null,
            };
            const createSession = await createTrainingSession(params);
            if (createSession.statusCode === 200) {
                handleTrainingSessions();
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    responseMessage: createSession.message,
                    training_name: "",
                    training_name_error: "",
                    selectedGroupIds: "",
                    selectedVillageIds: "",
                    selected_village_ids_error: "",
                    selected_group_ids_error: "",
                    schedule_date: "",
                    schedule_date_error: "",
                    loading: false,
                    villageDetails: [],
                    groupDetails: [],
                    trainingTypeId: "",
                    trainingTypeIdError: "",
                }));

                setSnackbar({
                    open: true,
                    message: createSession.message,
                    severity: "success",
                });

                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        } catch (error) {
            console.error(error);
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    };

    const handleInputChange = (name, value) => {

        setState((prevState) => ({
            ...prevState,
            [name]: value,
            training_name_error: "",
            selected_group_ids_error: "",
            selected_village_ids_error: "",
            schedule_date_error: "",
            trainingTypeIdError: "",
        }));

        if (name === "trainingTypeId") {
            setState((prevState) => ({
                ...prevState,
                training_name: "",
                training_name_error: "",
                selectedGroupIds: "",
                selectedVillageIds: "",
                selected_village_ids_error: "",
                selected_group_ids_error: "",
                schedule_date: "",
                schedule_date_error: "",
            }));
        } else if (name === "training_name") {
            setState((prevState) => ({
                ...prevState,
                training_name_error: "",
                selectedGroupIds: "",
                selectedVillageIds: "",
                selected_village_ids_error: "",
                selected_group_ids_error: "",
                schedule_date: "",
                schedule_date_error: "",
            }));
        }
    };


    useEffect(() => {
        if (state.training_name) {

            let trainingSessionsData = trainingSessions.filter(
                (item) => item.training_content_id === parseInt(state.training_name, 10)
            );

            const ffGroupData = villageGroups.find((item) => item.level_id === 4);

            const groupData = ffGroupData?.data
                .filter(item => item.group_id !== "")
                .map((item) => ({ value: item.group_id, label: item.Groups }))
                .filter((group) =>
                    !trainingSessionsData.some(
                        (session) => session.group_ids === group.value
                    )
                );


            const villageData = ffGroupData?.data
                .filter(item => item.village_id !== "")
                .map((item) => ({ value: item.village_id, label: item.village }))
                .filter((village) =>
                    !trainingSessionsData.some(
                        (session) => session.village_id === village.value
                    )
                );

            setState((prev) => ({
                ...prev,
                villageDetails: villageData || [],
                groupDetails: groupData || []
            }));
        } else {
            setState((prev) => ({
                ...prev,
                villageDetails: [],
                groupDetails: []
            }));
        }
    }, [state.training_name, villageGroups, trainingSessions]);


    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return (
        <Box>
            <Card elevation={6}>
                <CardContent>
                    <Grid container spacing={2}>
                        {
                            [
                                { id: 1, name: "trainingTypeId", label: "Select Training Type", value: state.trainingTypeId, options: trainingTypes, error: state.trainingTypeIdError },
                                { id: 2, name: "training_name", label: "Select Training Plan", value: state.training_name, options: training_Plans, error: state.training_name_error },
                                ...user?.level_id === 1 ? [{ id: 3, name: "selectedVillageIds", label: "Select Villages", value: state.selectedVillageIds, options: state.villageDetails, error: state.selected_village_ids_error }] :
                                    [{ id: 4, name: "selectedGroupIds", label: "Select Groups", value: state.selectedGroupIds, options: state.groupDetails, error: state.selected_group_ids_error }],
                                { id: 5, name: "schedule_date", label: "schedule Date", value: state.schedule_date, error: state.schedule_date_error }
                            ].map((field) => (
                                <Grid item size={{ xs: 12, md: 3 }} key={field.id}>
                                    {
                                        field.id === 5 ? (
                                            <TextField
                                                fullWidth
                                                type="datetime-local"
                                                size="small"
                                                name={field.name}
                                                label={field.label}
                                                value={field.value}
                                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                                                error={!!field.error}
                                                helperText={field.error}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        ) : (
                                            <SingleSelect
                                                name={field.name}
                                                label={field.label}
                                                options={field.options}
                                                value={field.value}
                                                disabled={field.disabled}
                                                onChange={handleInputChange}
                                                error={field.error}
                                                formHelperText={true}
                                            />
                                        )
                                    }
                                </Grid>
                            ))
                        }
                    </Grid>
                </CardContent>

                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.loading === true ? "loading" : "idle"}
                        onClick={handleCheduleCreationSubmit}
                        label=" Create Session"
                        loadingLabel="Submitting.."
                    />
                </CardActions>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </Box>
    )
}
export default TrainingSessionCreation;